import {Vanity} from "../../parts/vanity";
import {createParentPositions, METADATA, LOOK_ROOM_TYPES, LayoutAbbreviations} from "../../constants";
import VanityCommon from "./vanityCommon";
import {getCurrentRoomType} from "../../../../appLayout";

export default class VanityCountertop extends VanityCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_countertop';
    this.partName = 'Countertop';
    this.translateId = "visualizer.bathroom.vanity.vanity_countertop";
    this.homePageTitle = 'Countertops';
    this.visible = [Vanity.Types.Custom];
    this.isStoneFeature = true;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
      this.nextFeaturesPageToLoadArray = {};
      LayoutAbbreviations.forEach(layoutAbbreviation => {
        this.nextFeaturesPageToLoadArray[layoutAbbreviation] = {
          page: 0,
          allReceived: false,
        };
      });
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["MatchingFeature"]) {
      dbFeature.metaData["MatchingFeature"] = [METADATA.NO];
    }
    if (!dbFeature.metaData["Side"]) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    return super.load(dbFeature);
  }

  disabledClick() {
    // this.getParent().toggleVanityParts(this.disabled); // temporary removed for demo
  }

  getArrayOfConditions() {
    const vanityParent = this.getParent();
    let conditions = super.getArrayOfConditions();
    if (getCurrentRoomType(vanityParent.layout) === LOOK_ROOM_TYPES.as) {
      const activeMatchingSink = vanityParent.getActiveMatchingMetaFromRelatedItem("vanity_sink");
      const activeMatchingSinkSku = vanityParent.getActiveSkuFromRelatedItem("vanity_sink");
      if ((activeMatchingSink && activeMatchingSink.includes(METADATA.NO)) || activeMatchingSinkSku) {
        const propValue = !activeMatchingSink.includes(METADATA.NO) && activeMatchingSinkSku ? activeMatchingSinkSku : activeMatchingSink;
        conditions.push({
          propName: "MatchingFeature",
          propValue,
        });
        if (!(Array.isArray(propValue) && propValue[0] === METADATA.NO)) { // remove since we need to use Lixil matchingfeature logic
          conditions = conditions.filter(condition => condition.propName !== "VanitySize");
        }
      }
      const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type, "Side");
      if (activeSideMeta && activeSideMeta.includes("C")) {
        conditions.push({
          propName: "Side",
          propValue: activeSideMeta
        });
      }
    }
    return conditions
  }
}
